import { createAsyncAction } from 'typesafe-actions'
import { ReadTradingHistoryRequestDto, ReadTradingHistoryResponseDto } from '@sparling/financial-common'

export const {
  request: getTradingHistoryRequest,
  success: getTradingHistorySuccess,
  failure: getTradingHistoryFailure,
} = createAsyncAction('GET_TRADING_HISTORY_REQUEST', 'GET_TRADING_HISTORY_SUCCESS', 'GET_TRADING_HISTORY_FAILURE')<
  { idSf: string } & ReadTradingHistoryRequestDto,
  ReadTradingHistoryResponseDto,
  Error
>()
